// Fun and friendly adjectives for guest names
const adjectives = [
  'Happy', 'Cheerful', 'Bright', 'Swift', 'Clever', 'Creative', 'Focused', 'Calm',
  'Bold', 'Smart', 'Quick', 'Wise', 'Kind', 'Gentle', 'Brave', 'Cool',
  'Awesome', 'Amazing', 'Super', 'Great', 'Fantastic', 'Wonderful', 'Brilliant', 'Stellar',
  'Dynamic', 'Energetic', 'Vibrant', 'Lively', 'Spirited', 'Active', 'Motivated', 'Inspired',
  'Productive', 'Efficient', 'Organized', 'Balanced', 'Mindful', 'Peaceful', 'Serene', 'Tranquil'
];

// Fun animal names and nature-inspired nouns
const nouns = [
  'Panda', 'Dolphin', 'Eagle', 'Fox', 'Wolf', 'Bear', 'Lion', 'Tiger',
  'Owl', 'Hawk', 'Falcon', 'Robin', 'Sparrow', 'Raven', 'Cardinal', 'Hummingbird',
  'Butterfly', 'Dragonfly', 'Bee', 'Firefly', 'Ladybug', 'Cricket', 'Grasshopper', 'Ant',
  'Star', 'Moon', 'Sun', 'Ocean', 'River', 'Mountain', 'Forest', 'Meadow',
  'Rainbow', 'Thunder', 'Lightning', 'Breeze', 'Storm', 'Cloud', 'Mist', 'Aurora',
  'Explorer', 'Adventurer', 'Dreamer', 'Creator', 'Builder', 'Learner', 'Thinker'
];

/**
 * Generates a random friendly name for guest users
 * Format: "Adjective Noun" (e.g., "Happy Panda", "Creative Eagle")
 */
export function generateRandomGuestName(): string {
  const randomAdjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const randomNoun = nouns[Math.floor(Math.random() * nouns.length)];
  
  return `${randomAdjective} ${randomNoun}`;
}

/**
 * Generates a random friendly name with a number suffix for extra uniqueness
 * Format: "Adjective Noun ###" (e.g., "Happy Panda 247", "Creative Eagle 891")
 */
export function generateRandomGuestNameWithNumber(): string {
  const baseName = generateRandomGuestName();
  const randomNumber = Math.floor(Math.random() * 999) + 1;
  
  return `${baseName} ${randomNumber}`;
} 